import { graphql } from 'react-relay';
import type { ZnglyVideos_Frontend_Pagination_Fragment_Query$variables } from './__generated__/ZnglyVideos_Frontend_Pagination_Fragment_Query.graphql';
import type { ZnglyVideos_Pagination_Query$variables } from './__generated__/ZnglyVideos_Pagination_Query.graphql';

export * from './__generated__/ZnglyVideos_Pagination_Fragment.graphql';

export type ZnglyVideos_Pagination_Fragment$args = ZnglyVideos_Pagination_Query$variables;

export const ZnglyVideosPaginationFragment = graphql`
  fragment ZnglyVideos_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToZnglyVideoConnectionWhereArgs" }
  )
  @refetchable(queryName: "ZnglyVideos_Pagination_Query") {
    znglyVideos(first: $first, after: $after, where: $where)
      @connection(key: "ZnglyVideos_Pagination_Fragment_Connection_znglyVideos") {
      __id
      edges {
        node {
          ...ZnglyVideo_Pagination_Node_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export * from './__generated__/ZnglyVideos_Query.graphql';
export const ZnglyVideosQuery = graphql`
  query ZnglyVideos_Query {
    ...ZnglyVideos_Pagination_Fragment
      @arguments(
        first: 24
        after: null
        where: {
          search: null
          orderby: null
          mediaName: null
          stati: [PENDING, PUBLISH, HIDDEN, HIDDEN_B_S, DRAFT]
          authorIn: null
          dateQuery: null
        }
      )
  }
`;

export type {
  ZnglyVideo_Pagination_Node_Fragment$data,
  ZnglyVideo_Pagination_Node_Fragment$key,
} from './__generated__/ZnglyVideo_Pagination_Node_Fragment.graphql';
const ZnglyVideoPaginationNodeFragment = graphql`
  fragment ZnglyVideo_Pagination_Node_Fragment on ZnglyVideo {
    id
    databaseId
    title
    link
    date
    status
    trashDate
    trashTimeUntil
    author {
      ...Frags_With_Author_Fragment @relay(mask: false)
    }
    categories(first: 100) {
      edges {
        node {
          name
        }
      }
    }
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    znglyContent {
      aiSummary
      contentEmbedHtml
      contentMediaName
      contentMediaType
      contentLink
      contentFile {
        ...Media_Url_Fragment @relay(mask: false)
      }
      featuredImageFile {
        ...Media_Url_Fragment @relay(mask: false)
      }
      featuredImageLink
      ctaLink
      ctaName
      form {
        node {
          ...Frags_Frontend_Form_Fragment @relay(mask: false)
        }
      }
      htmlDesc
      shortText
    }
  }
`;

export type {
  ZnglyVideo_Single_Fragment$data,
  ZnglyVideo_Single_Fragment$key,
} from './__generated__/ZnglyVideo_Single_Fragment.graphql';
export const ZnglyVideoFragment = graphql`
  fragment ZnglyVideo_Single_Fragment on ZnglyVideo {
    id
    author {
      ...Frags_With_Author_Fragment @relay(mask: false)
    }
    databaseId
    title
    link
    status
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    searchResults {
      ...Frags_Ai_Search_Results_Fragment @relay(mask: false)
    }
    znglyContent {
      aiSummary
      ctaLink
      ctaName
      contentMediaType
      contentLink
      contentEmbedHtml
      contentMediaName
      contentFile {
        ...Media_Url_Fragment @relay(mask: false)
      }
      featuredImageLink
      featuredImageFile {
        ...Media_Url_Fragment @relay(mask: false)
      }
      shortText
      htmlDesc
      form {
        node {
          ...Frags_Frontend_Form_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export type {
  ZnglyVideos_Frontend_Pagination_Fragment$data,
  ZnglyVideos_Frontend_Pagination_Fragment$key,
} from './__generated__/ZnglyVideos_Frontend_Pagination_Fragment.graphql';

export type ZnglyVideos_Frontend_Pagination_Fragment$args = ZnglyVideos_Frontend_Pagination_Fragment_Query$variables;

export const ZnglyVideosFrontendPaginationFragment = graphql`
  fragment ZnglyVideos_Frontend_Pagination_Fragment on RootQuery 
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToZnglyVideoConnectionWhereArgs" }
  )
  @refetchable(queryName: "ZnglyVideos_Frontend_Pagination_Fragment_Query") {
    znglyVideos(first: $first, after: $after, where: $where)
      @connection(key: "ZnglyVideos_Frontend_Pagination_Fragment_Connection_znglyVideos") {
      __id
      edges {
        node {
          ...ZnglyVideo_Single_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export type {
  ZnglyVideos_Frontend_Query,
  ZnglyVideos_Frontend_Query$data,
  ZnglyVideos_Frontend_Query$variables,
} from './__generated__/ZnglyVideos_Frontend_Query.graphql';
export const ZnglyVideosFrontendQuery = graphql`
  query ZnglyVideos_Frontend_Query($first: Int = 12, $after: String = null, $where: RootQueryToZnglyVideoConnectionWhereArgs = null) {
    ...ZnglyVideos_Frontend_Pagination_Fragment @arguments(first: $first, after: $after, where: $where)
  }
`;
